import { css, cva } from "styled-system/css";

/** Full-viewport Capacitor / native app shell. */
export const appStyles = css({
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
  width: "100%",
  overflow: "hidden",
  fontFamily: "sans",
  color: "textBase",
  backgroundColor: "bgBase200",
});

/** Scrollable main content region inside the shell. */
export const mainStyles = css({
  flex: 1,
  overflowY: "auto",
  width: "100%",
  position: "relative",
});

export const safeAreaTopStyles = css({
  height: "env(safe-area-inset-top)",
  backgroundColor: "bgBase100",
  width: "100%",
  flexShrink: 0,
  display: { base: "block", md: "none" },
});

export const safeAreaBottomStyles = css({
  height: "env(safe-area-inset-bottom)",
  backgroundColor: "bgBase100",
  width: "100%",
  flexShrink: 0,
  order: 2,
  display: { base: "block", md: "none" },
});

/** Shared max content width for page containers and full-bleed inner content. */
export const contentMaxWidth = "920px";

export const containerStyles = css({
  width: "100%",
  maxWidth: contentMaxWidth,
  marginInline: "auto",
  paddingInline: "md",
});

export const bottomBarContainerStyles = css({
  width: "100%",
  paddingInline: "md",
  backgroundColor: "color-mix(in srgb, {colors.bgBase100}, transparent 10%)",
  backdropFilter: "blur(12px)",
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  borderTopColor: "bgBase200",
  zIndex: 50,
  flexShrink: 0,
});

export const bottomBarInnerStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "3rem",
  gap: "xs",
});

export const bottomBarItemStyles = cva({
  base: {
    cursor: "pointer",
    userSelect: "none",
    border: "none",
    padding: 0,
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3rem",
    height: "3rem",
    borderRadius: "full",
    color: "color-mix(in srgb, {colors.textBase}, transparent 60%)",
    backgroundColor: "transparent",
    transitionProperty: "all",
    transitionDuration: "200ms",
    _hover: {
      backgroundColor: "color-mix(in srgb, {colors.textBase}, transparent 95%)",
    },
    _active: {
      backgroundColor: "color-mix(in srgb, {colors.textBase}, transparent 90%)",
    },
    _disabled: {
      opacity: 0.3,
      cursor: "not-allowed",
    },
  },
  variants: {
    active: {
      true: {
        color: "primary",
      },
    },
  },
});
